"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Graphics = require("../../graphics");

var Specification = require("../../specification");

var emphasis_1 = require("./emphasis");

var symbol_attrs_1 = require("./symbol.attrs");

var SymbolElementClass =
/*#__PURE__*/
function (_emphasis_1$Emphasiza) {
  _inherits(SymbolElementClass, _emphasis_1$Emphasiza);

  function SymbolElementClass() {
    var _this;

    _classCallCheck(this, SymbolElementClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SymbolElementClass).apply(this, arguments));
    _this.attributes = symbol_attrs_1.symbolAttributes;
    _this.attributeNames = Object.keys(symbol_attrs_1.symbolAttributes);
    return _this;
  }

  _createClass(SymbolElementClass, [{
    key: "initializeState",
    value: function initializeState() {
      _get(_getPrototypeOf(SymbolElementClass.prototype), "initializeState", this).call(this);

      var attrs = this.state.attributes;
      attrs.x = 0;
      attrs.y = 0;
      attrs.size = 60;
      attrs.fill = {
        r: 128,
        g: 128,
        b: 128
      };
      attrs.strokeWidth = 1;
      attrs.opacity = 1;
      attrs.visible = true;
      attrs.symbol = "circle";
    }
    /** Get link anchors for this mark */

  }, {
    key: "getLinkAnchors",
    value: function getLinkAnchors(mode) {
      var attrs = this.state.attributes;
      return [{
        element: this.object._id,
        points: [{
          x: attrs.x,
          y: attrs.y,
          xAttribute: "x",
          yAttribute: "y",
          direction: {
            x: mode == "begin" ? 1 : -1,
            y: 0
          }
        }]
      }];
    } // Get the graphical element from the element

  }, {
    key: "getGraphics",
    value: function getGraphics(cs, offset) {
      var glyphIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var manager = arguments.length > 3 ? arguments[3] : undefined;
      var emphasize = arguments.length > 4 ? arguments[4] : undefined;
      var attrs = this.state.attributes;

      if (!attrs.visible || !this.object.properties.visible) {
        return null;
      }

      if (attrs.size <= 0) {
        return null;
      }

      var pc = cs.transformPoint(attrs.x + offset.x, attrs.y + offset.y);
      var style = Object.assign({
        strokeColor: attrs.stroke,
        strokeWidth: attrs.strokeWidth,
        fillColor: attrs.fill,
        opacity: attrs.opacity
      }, this.generateEmphasisStyle(emphasize));

      switch (attrs.symbol) {
        case "square":
          {
            var w = Math.sqrt(attrs.size);
            return {
              type: "rect",
              style: style,
              x1: pc.x - w / 2,
              y1: pc.y - w / 2,
              x2: pc.x + w / 2,
              y2: pc.y + w / 2
            };
          }

        case "cross":
          {
            var r = Math.sqrt(attrs.size / 5) / 2;
            var path = Graphics.makePath(style);
            path.moveTo(pc.x - 3 * r, pc.y - r);
            path.lineTo(pc.x - r, pc.y - r);
            path.lineTo(pc.x - r, pc.y - 3 * r);
            path.lineTo(pc.x + r, pc.y - 3 * r);
            path.lineTo(pc.x + r, pc.y - r);
            path.lineTo(pc.x + 3 * r, pc.y - r);
            path.lineTo(pc.x + 3 * r, pc.y + r);
            path.lineTo(pc.x + r, pc.y + r);
            path.lineTo(pc.x + r, pc.y + 3 * r);
            path.lineTo(pc.x - r, pc.y + 3 * r);
            path.lineTo(pc.x - r, pc.y + r);
            path.lineTo(pc.x - 3 * r, pc.y + r);
            path.closePath();
            return path.path;
          }

        case "diamond":
          {
            var tan30 = 0.5773502691896257; // Math.sqrt(1 / 3);

            var tan30_2 = 1.1547005383792515; // tan30 * 2;

            var y = Math.sqrt(attrs.size / tan30_2),
                x = y * tan30;

            var _path = Graphics.makePath(style);

            _path.moveTo(pc.x, pc.y - y);

            _path.lineTo(pc.x + x, pc.y);

            _path.lineTo(pc.x, pc.y + y);

            _path.lineTo(pc.x - x, pc.y);

            _path.closePath();

            return _path.path;
          }

        case "star":
          {
            var ka = 0.8908130915292852281;
            var kr = 0.3819660112501051; // Math.sin(Math.PI / 10) / Math.sin(7 * Math.PI / 10),

            var kx = 0.22451398828979266; // Math.sin(2 * Math.PI / 10) * kr;

            var ky = -0.3090169943749474; // -Math.cos(2 * Math.PI / 10) * kr;

            var _r = Math.sqrt(attrs.size * ka),
                _x = kx * _r,
                _y = ky * _r;

            var _path2 = Graphics.makePath(style);

            _path2.moveTo(pc.x, pc.y - _r);

            _path2.lineTo(pc.x + _x, pc.y + _y);

            for (var i = 1; i < 5; ++i) {
              var a = Math.PI * 2 * i / 5,
                  c = Math.cos(a),
                  s = Math.sin(a);

              _path2.lineTo(pc.x + s * _r, pc.y - c * _r);

              _path2.lineTo(pc.x + c * _x - s * _y, pc.y + s * _x + c * _y);
            }

            _path2.closePath();

            return _path2.path;
          }

        case "triangle":
          {
            var sqrt3 = Math.sqrt(3);

            var _y2 = -Math.sqrt(attrs.size / (sqrt3 * 3));

            var _path3 = Graphics.makePath(style);

            _path3.moveTo(pc.x, pc.y + _y2 * 2);

            _path3.lineTo(pc.x - sqrt3 * _y2, pc.y - _y2);

            _path3.lineTo(pc.x + sqrt3 * _y2, pc.y - _y2);

            _path3.closePath();

            return _path3.path;
          }

        case "wye":
          {
            var _c = -0.5,
                _s = Math.sqrt(3) / 2,
                k = 1 / Math.sqrt(12),
                _a = (k / 2 + 1) * 3;

            var _r2 = Math.sqrt(attrs.size / _a),
                x0 = _r2 / 2,
                y0 = _r2 * k,
                x1 = x0,
                y1 = _r2 * k + _r2,
                x2 = -x1,
                y2 = y1;

            var _path4 = Graphics.makePath(style);

            _path4.moveTo(pc.x + x0, pc.y + y0);

            _path4.lineTo(pc.x + x1, pc.y + y1);

            _path4.lineTo(pc.x + x2, pc.y + y2);

            _path4.lineTo(pc.x + _c * x0 - _s * y0, pc.y + _s * x0 + _c * y0);

            _path4.lineTo(pc.x + _c * x1 - _s * y1, pc.y + _s * x1 + _c * y1);

            _path4.lineTo(pc.x + _c * x2 - _s * y2, pc.y + _s * x2 + _c * y2);

            _path4.lineTo(pc.x + _c * x0 + _s * y0, pc.y + _c * y0 - _s * x0);

            _path4.lineTo(pc.x + _c * x1 + _s * y1, pc.y + _c * y1 - _s * x1);

            _path4.lineTo(pc.x + _c * x2 + _s * y2, pc.y + _c * y2 - _s * x2);

            _path4.closePath();

            return _path4.path;
          }

        default:
          {
            return {
              type: "circle",
              style: style,
              cx: pc.x,
              cy: pc.y,
              r: Math.sqrt(attrs.size / Math.PI)
            };
          }
      }
    } // Get DropZones given current state

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y,
          size = attrs.size;
      var r = Math.sqrt(size);
      return [{
        type: "line",
        p1: {
          x: x + r,
          y: y
        },
        p2: {
          x: x - r,
          y: y
        },
        title: "size",
        dropAction: {
          scaleInference: {
            attribute: "size",
            attributeType: Specification.AttributeType.Number,
            hints: {
              rangeNumber: [0, 200 * Math.PI]
            }
          }
        }
      }];
    } // Get bounding rectangle given current state

  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y;
      return [{
        type: "point",
        x: x,
        y: y,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y"
        }]
      }];
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y,
          size = attrs.size;
      return {
        type: "circle",
        cx: x,
        cy: y,
        radius: Math.sqrt(size / Math.PI)
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y;
      return [{
        type: "x",
        value: x,
        attribute: "x"
      }, {
        type: "y",
        value: y,
        attribute: "y"
      }];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var widgets = [manager.sectionHeader("Symbol"), manager.mappingEditor("Shape", "symbol", {
        acceptKinds: [Specification.DataKind.Categorical],
        hints: {
          rangeEnum: symbol_attrs_1.symbolTypes
        },
        defaultValue: "circle"
      }), manager.mappingEditor("Size", "size", {
        acceptKinds: [Specification.DataKind.Numerical],
        hints: {
          rangeNumber: [0, 200 * Math.PI]
        },
        defaultValue: 60,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          sliderRange: [0, 3600],
          sliderFunction: "sqrt"
        }
      }), manager.sectionHeader("Style"), manager.mappingEditor("Fill", "fill", {}), manager.mappingEditor("Stroke", "stroke", {})];

      if (this.object.mappings.stroke != null) {
        widgets.push(manager.mappingEditor("Line Width", "strokeWidth", {
          hints: {
            rangeNumber: [0, 5]
          },
          defaultValue: 1,
          numberOptions: {
            showSlider: true,
            sliderRange: [0, 5],
            minimum: 0
          }
        }));
      }

      widgets = widgets.concat([manager.mappingEditor("Opacity", "opacity", {
        hints: {
          rangeNumber: [0, 1]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          maximum: 1
        }
      }), manager.mappingEditor("Visibility", "visible", {
        defaultValue: true
      })]);
      return widgets;
    }
  }]);

  return SymbolElementClass;
}(emphasis_1.EmphasizableMarkClass);

SymbolElementClass.classID = "mark.symbol";
SymbolElementClass.type = "mark";
SymbolElementClass.metadata = {
  displayName: "Symbol",
  iconPath: "mark/symbol",
  creatingInteraction: {
    type: "point",
    mapping: {
      x: "x",
      y: "y"
    }
  }
};
SymbolElementClass.defaultProperties = {
  visible: true
};
SymbolElementClass.defaultMappingValues = {
  fill: {
    r: 217,
    g: 217,
    b: 217
  },
  strokeWidth: 1,
  opacity: 1,
  size: 60,
  visible: true
};
exports.SymbolElementClass = SymbolElementClass;